import { o_util } from "../../../common/namespaces.js";
import { getAssignments } from "./getAssignments.js";

const onexSync = o_util.onex;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const isOnexVariantAsync = async (onexId: string, variantId: string): Promise<boolean> =>
  onexSync.isOnexVariant.call(
    onexSync.customAssignments(await getAssignments()),
    onexId,
    variantId,
  );

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const mapOnexVariantAsync = async <OnexMap extends Record<string, unknown>, D = undefined>(
  onexId: string,
  variantMap: OnexMap,
  ...a: undefined extends D ? [] : [defaultValue: D]
): Promise<OnexMap[keyof OnexMap] | D> =>
  onexSync.mapOnexVariant.call(
    onexSync.customAssignments(await getAssignments()),
    onexId,
    variantMap,
    ...(a as []),
  ) as Promise<OnexMap[keyof OnexMap] | D>;
